<mat-card class="stepper">



  <div class="allStepWithBack">
    <!-- <button mat-stroked-button color="primary" (click)="SubmitBackButton()" matTooltip="Back">
      Back
    </button> -->

    <div class="allSteps">

      <div [ngClass]="stepCompleted >0 ? 'active step done' : 'active step'">
        <div class="stepStatus">
          <span class="nmbr">1</span>
          <span class="stepName">Upload Document</span>
          <span class="stepIcon">
            <mat-icon>picture_as_pdf</mat-icon>
          </span>
        </div>
      </div>
  
      <div [ngClass]="stepCompleted >1 ? 'active step done' : 'step'">
        <div class="stepStatus" (click)="showAllParticipant()">
          <span class="nmbr">2</span>
          <span class="stepName">Add Participant</span><span class="stepIcon">
            <mat-icon>account_box</mat-icon>
          </span>
        </div>
      </div>
  
      <div [ngClass]="stepCompleted >2 ? 'active step done' : 'step'">
        <div class="stepStatus" (click)="showFormEditor()">
          <span class="nmbr">3</span>
          <span class="stepName">Design Form</span>
          <span class="stepIcon">
            <mat-icon>design_services</mat-icon>
          </span>
        </div>
      </div>
  
      <div [ngClass]="stepCompleted >3 ? 'active step done' : 'step'">
        <div class="stepStatus" (click)="showFormFinish()">
          <span class="nmbr">4</span>
          <span class="stepName">Review & Send </span>
          <span class="stepIcon">
            <mat-icon>send</mat-icon>
          </span>
        </div>
      </div>
    </div>

    
    <button [disabled]="!ShowNextButton" matTooltip="Next" mat-flat-button color="primary" (click)="SubmitNextButton()">
      Next
    </button>
  </div>

</mat-card>




<div class="formWrapper">


  <mat-card class="container">

    <div class="saveName" *ngIf="modulename == 'Form' || modulename == 'Template'">
      <mat-form-field [ngClass]="{'bounce' : projectNameExist}">
        <mat-label *ngIf="type == '1'">Project Name</mat-label>
        <mat-label *ngIf="type == '2'">Template Name</mat-label>
        <input matInput placeholder="Add {{projectTempName}} Name" [(ngModel)]="projectName" #projectnameadd
          maxlength="100" (input)="onChange($event.target.value)" required>
        <mat-icon *ngIf="type == '1'" matSuffix class="type">work_outline</mat-icon>
        <mat-icon *ngIf="type == '2'" matSuffix>work_outline</mat-icon>
      </mat-form-field>

      <div class="concernPersonHolder">
        <div class="concernPerson">
       <mat-slide-toggle [(ngModel)]="selected3cType"></mat-slide-toggle>  <label>Create/Update {{CoreShowName}} When Sent</label>
        
      </div>

      <div class="concernPerson">
        <mat-slide-toggle [(ngModel)]="isProgressiveForm"></mat-slide-toggle>
        <label>Progressive Form</label>
        
      </div>
      </div>


    </div>


    <div class="page_header">
      <div class="back">
        <!-- <button mat-flat-button > <mat-icon>keyboard_arrow_left</mat-icon> Back </button> -->
      </div>
      <span>Add Documents </span>
    </div>




    <div class="step one" id="step1">
      <mat-card class="documentList">
        <div class="importFile">
          <div class="upDoc ">
            <div class="uploadholder">
              <input #Input type="file" multiple (change)="selectFiles($event)" />
              <mat-icon>picture_as_pdf</mat-icon>
              <div class="textIn">
                <p>Drag and drop files here </p>
                <span class="ml-5 mr-5">or</span>
                <p>click here to browse the files</p>
              </div>
            </div>
          </div>

          <div class="othOption">

            <button *ngIf="showImportTemplate" mat-stroked-button color="primary" [disabled]="!ImportTemplateShow"
              (click)="selectForm(forms)">
              <mat-icon>note_add</mat-icon> Import Template
            </button>

            <button mat-stroked-button color="primary" (click)="selectDrive(drive)">
              <mat-icon>add_to_drive</mat-icon> My Drive
            </button>
            <button mat-stroked-button color="primary" (click)="loadAndProcessDefaultFile()">
              <mat-icon>picture_as_pdf</mat-icon> Blank PDF
            </button>

          </div>

        </div>

      </mat-card>


      <!--   -->
      <mat-card class="uploadDocuments">
        <h3 *ngIf="UploadingFiles.length > 0">Uploading</h3>
        <mat-card class="fileCont " *ngFor="let file of UploadingFiles">
          <div class="DragIcon" cdkDragHandle>
            <mat-icon>drag_indicator</mat-icon>
          </div>
          <div class="Icon" *ngIf="file.documentType == 'pdf' || file.documentType == 'PDF'">
            <img src="../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
          </div>

          <div class="Icon" *ngIf="file.documentType == 'jpg' || file.documentType == 'jpeg'">
            <img src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File" />
          </div>

          <div class="Icon" *ngIf=" file.documentType == 'png' ||  file.documentType == 'gif' ||
              file.documentType == 'tiff' || file.documentType == 'bmp'">
            <img src="../../../../../assets/icons/fileType/020-png.svg" alt="png File" />
          </div>
          <div class="nameInfo flex-col">
            <h2>{{ file.fileName }}</h2>

            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>

          <div class="docAct">
            <!-- <button (click)="deleteFile(file)" mat-icon-button matTooltipClass="tooltip" matTooltip="Delete">
              <mat-icon>cancel</mat-icon>
            </button> -->
          </div>

        </mat-card>
      </mat-card>

      <mat-card class="uploadDocuments" *ngIf="UploadedNewFiles.length > 0">
        <h3>Uploaded</h3>
        <div cdkDropList class="fileHolder" (cdkDropListDropped)="drop($event)">
          <div class="example-box" *ngFor="let file of UploadedFiles" cdkDrag>
            <ng-container *ngIf="!file.isDeleted">

              <div class="example-custom-placeholder" *cdkDragPlaceholder></div>

              <mat-card [ngClass]="file.isCompressed ? 'fileCont addCompress' : 'fileCont'">
                <div class="DragIcon" cdkDragHandle>
                  <mat-icon>drag_indicator</mat-icon>
                </div>

                <div class="Icon"
                  *ngIf="file.documentType == 'pdf' || file.documentType == '.pdf' || file.documentType == 'PDF'">
                  <img src="../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
                </div>

                <!-- <div class="Icon"
                *ngIf="file.documentType == 'jpg' || file.documentType == 'jpeg' || file.documentType == 'image/jpeg'">
                <img src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File"/>
              </div> -->

                <!-- <div class="Icon" *ngIf="file.documentType == 'png' || file.documentType == 'gif' ||
                  file.documentType == 'tiff' ||
                  file.documentType == 'bmp'">
                <img src="../../../../../assets/icons/fileType/020-png.svg" alt="png File"/>
              </div> -->

                <div class="nameInfo">
                  <h2>{{ file.fileName }}</h2>
                  <p>{{ file.Totalsize }}</p>
                  <p *ngIf="file.pageCount">Total Pages: {{ file.pageCount }}</p>
                </div>

                <div class="docAct">
                  <ng-container *ngIf='file.isCompressed'>
                    <button color="primary" mat-icon-button matTooltipClass="tooltip" matTooltip="Compress"
                      (click)="compressFile(file)">
                      <mat-icon>compress</mat-icon>
                    </button>
                  </ng-container>
                  <!-- <ng-container *ngIf='convertString(file.Totalsize)>=100'>
                    <button color="primary" mat-icon-button matTooltipClass="tooltip" matTooltip="Compress" 
                    (click)="compressFile(file)">
                      <mat-icon>compress</mat-icon>
                    </button>
                  </ng-container> -->
                  <ng-container *ngIf='file.pdfToImageStatus==0'>
                    <button color="primary" mat-icon-button matTooltipClass="tooltip" matTooltip="Pending">
                      <mat-icon>refresh</mat-icon>
                    </button>
                  </ng-container>
                  <ng-container *ngIf='file.pdfToImageStatus==1'>
                    <button color="primary" mat-icon-button matTooltipClass="tooltip" matTooltip="Inprogress">
                      <mat-icon>downloading</mat-icon>
                    </button>
                  </ng-container>
                  <ng-container *ngIf='file.pdfToImageStatus==2'>
                    <button color="warn" mat-icon-button matTooltipClass="tooltip" matTooltip="Error, Please retry"
                      (click)="retryPdfToImage(file)">
                      <mat-icon>sync_problem</mat-icon>
                    </button>
                  </ng-container>
                  <!-- <ng-container *ngIf='type==2'>-->
                  <ng-container>
                    <button mat-icon-button color="basic"  matTooltipClass="tooltip" matTooltip="Replace" >
                      <input type="file" #ReplaceInput id="replacefile" name="replacefile"
                      (change)="selectReplaceFile($event,file)" style="display: none;" />
                      <mat-icon (click)="replaceClick()">content_paste_go</mat-icon>
                    </button>
                  </ng-container>
                  <ng-container *ngIf='file.pdfToImageStatus==3'>
                    <mat-icon class="doneConvert" matTooltipClass="tooltip" matTooltip="Converted">
                      published_with_changes</mat-icon>
                  </ng-container>

                  <button (click)="openDialogWithRef(myDialog, file)" mat-icon-button color="basic"
                    matTooltipClass="tooltip" matTooltip="Rename">
                    <mat-icon>font_download</mat-icon>
                  </button>
                  <button (click)="downloadPdf(file)" mat-icon-button color="basic" matTooltipClass="tooltip"
                    matTooltip="Download">
                    <mat-icon>cloud_download</mat-icon>
                  </button>
                  <button (click)="deleteFileFromUploaded(file)" mat-icon-button color="basic" matTooltipClass="tooltip"
                    matTooltip="Delete">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </div>

              </mat-card>

            </ng-container>
          </div>
        </div>
      </mat-card>
    </div>

  </mat-card>
</div>

<ng-template #myDialog>
  <form [formGroup]="formDialog">
    <h2 mat-dialog-title>
      <span class="groupIcon">
        <mat-icon>description</mat-icon>
      </span>
      Rename Document
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">
      <mat-form-field class="example-full-width">
        <mat-label>File</mat-label>
        <input matInput [required]="true" placeholder="Edit file name" formControlName="filename"
          [(ngModel)]="editfilename.filename" />
        <mat-error
          *ngIf="formDialog.get('filename').invalid && (formDialog.get('filename').dirty || formDialog.get('filename').touched)">
          <span>This field is mandatory.</span>
        </mat-error>
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="formDialog.invalid" (click)="UpdateFileName()">
        Update
      </button>
    </mat-dialog-actions>

  </form>
</ng-template>




<ng-template #forms>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>note_add</mat-icon></span>
    My Template
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </h2>
  <mat-dialog-content>
    <div class="myforms">
      <div class="drive mainLink">
        <div class="folderName" (click)="GetAllForms()">
          <mat-icon class="type">account_balance</mat-icon>
          Forms
        </div>

        <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
          <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderID }" *matTreeNodeDef="let node"
            matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility: hidden;">
                arrow_right
              </mat-icon>

              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder</mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder_shared</mat-icon>
                <span class="flname" (click)="getFormFolderWithTemplatesLeftPanel(node)">{{node.formFolderName}}</span>
              </div>
            </div>
          </mat-tree-node>


          <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderID }"
            *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.formFolderName">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
              </mat-icon>
              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder</mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true"
                  (click)="getFormFolderWithTemplatesLeftPanel(node)">folder_shared</mat-icon>
                <span class="flname" (click)="getFormFolderWithTemplatesLeftPanel(node)">{{node.formFolderName}}</span>
              </div>
            </div>

          </mat-tree-node>
        </mat-tree>

        <div class="folderName" (click)="getSharedWithMe()" [ngClass]="{ 'active': SharedWithMeactive }">
          <mat-icon class="type">portrait</mat-icon> Shared with me
        </div>

      </div>

      <div class="driveDetail" *ngIf="isShowForm">

        <div class="breadcumb">
          <span (click)="breadCrumbMainClick()">Forms</span>
          <span *ngFor="let m of menuHeader;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumb(menuHeader, i)">{{ m.label }}</a>
          </span>
        </div>

        <mat-card class="files">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell wstar">&nbsp; </th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell">Name</th>
                <th class="mat-header-cell date">Created On</th>
                <th class="mat-header-cell date">Modified On</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of FormFolderListMiddleSection; let i = index;">
                <tr class="mat-row foldericon" (click)="radioChange(form,'MyForm')">
                  <td class="mat-cell wstar">
                    <span class="checkbo" *ngIf="form.type == 2">
                      <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                        (change)="radioChange(form,'MyForm')"></mat-radio-button>
                    </span>
                  </td>

                  <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                    <td class="mat-cell">
                      <mat-icon class="fav">grade</mat-icon>
                    </td>
                  </ng-container>

                  <ng-template #showFavorite>
                    <td class="mat-cell">
                      <mat-icon class="star">grade</mat-icon>
                    </td>
                  </ng-template>


                  <td class="mat-cell docType" *ngIf="form.type == 1 && form.isShared == false">
                    <mat-icon>folder</mat-icon>
                  </td>

                  <td class="mat-cell docType" *ngIf="form.type == 1 && form.isShared == true">
                    <mat-icon>folder_shared</mat-icon>
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==1">
                    <img src="../../../../assets/images/icons/formIcon.svg" alt="" width="28" />
                    <!-- <mat-icon>description</mat-icon> -->
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==2">
                    <img src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="28" />
                    <!-- <mat-icon>table_rows</mat-icon> -->
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 1">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell">
                    {{ form.createdOn +'Z'| date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn!=null">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn==null">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                </tr>
              </ng-container>

              <ng-container *ngIf="!FormFolderListMiddleSection">
                <tr>
                  <td colspan="7">
                    <p class="nocontent">No Items Found</p>
                  </td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </mat-card>
      </div>

      <div class="driveDetail" *ngIf="isSharedWithMe">

        <div class="breadcumb">
          <span (click)="breadCrumbMainSHaredWithMeClick()">Shared with me</span>
          <span *ngFor="let m of menuHeader;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumb(menuHeader, i)">{{ m.label }}</a>
          </span>
        </div>

        <mat-card class="files">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell wstar">&nbsp; </th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell">Name</th>
                <th class="mat-header-cell" *ngIf="parentID==0">Shared By</th>
                <th class="mat-header-cell date">Created On</th>
                <th class="mat-header-cell date">Modified On</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of SharedWithMeFormFolderList; let i = index;">
                <tr class="mat-row foldericon" (click)="radioChange(form,'SharedWithMe')">
                  <td class="mat-cell wstar">
                    <span class="checkbo" *ngIf="form.type == 2">
                      <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                        (change)="radioChange(form,'SharedWithMe')">

                      </mat-radio-button>
                    </span>
                  </td>

                  <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                    <td class="mat-cell">
                      <mat-icon class="fav">grade</mat-icon>
                    </td>
                  </ng-container>

                  <ng-template #showFavorite>
                    <td class="mat-cell">
                      <mat-icon class="star">grade</mat-icon>
                    </td>
                  </ng-template>

                  <td class="mat-cell docType" *ngIf="form.type == 1">
                    <mat-icon>folder</mat-icon>
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==1">
                    <img src="../../../../assets/images/icons/formIcon.svg" alt="" width="28" />
                    <!-- <mat-icon>description</mat-icon> -->
                  </td>

                  <td class="mat-cell docType formIcon" *ngIf="form.type == 2 && form.formType==2">
                    <img src="../../../../assets/images/icons/form_tabuler.svg" alt="" width="28" />
                    <!-- <mat-icon>table_rows</mat-icon> -->
                  </td>


                  <td class="mat-cell" (click)="getFormFolderWithFormTemplatesSharedWithMe(form)"
                    *ngIf="form.type == 1">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="parentID==0">
                    <span class="formName" matTooltipClass="tooltip">
                      {{ form.sharedbyFirstName }} {{ form.sharedbyLastName }}
                    </span>
                  </td>

                  <td class="mat-cell" (click)="getFormFolderWithFormTemplatesSharedWithMe(form)"
                    *ngIf="form.type == 1">
                    {{ form.createdOn | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    {{ form.createdOn | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" (click)="getFormFolderWithFormTemplatesSharedWithMe(form)"
                    *ngIf="form.type == 1">
                    {{ form.updatedOn | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.type == 2">
                    {{ form.updatedOn | date: "MM/dd/yyyy" }}
                  </td>

                </tr>
              </ng-container>

              <ng-container *ngIf="SharedWithMeFormFolderList.length==0">
                <tr>
                  <td colspan="7">
                    <p class="nocontent">No Items Found</p>
                  </td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </mat-card>
      </div>

    </div>


  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()">Cancel</button>
    <button mat-button color="primary" [disabled]="!selectButtonShow"
      (click)="SelectTemplateMergeSubmit()">Select</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #drive>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>note_add</mat-icon></span>
    My Drive
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </h2>
  <mat-dialog-content>

    <div class="myforms">
      <div class="drive mainLink">

        <div class="folderName" (click)="GetAllMyDrive()">
          <mat-icon class="type">account_balance</mat-icon>
          My Drive
        </div>

        <mat-tree [dataSource]="dataSourceFileManager" [treeControl]="treeControlFileManager">
          <mat-tree-node [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
            *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility: hidden;">
                arrow_right
              </mat-icon>

              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false"
                  (click)="showChildFolders(node)">folder</mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true"
                  (click)="showChildFolders(node)">folder_shared</mat-icon>
                <span class="flname" (click)="showChildFolders(node)">{{node.name}}</span>
              </div>
            </div>
          </mat-tree-node>

          <mat-tree-node [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
            *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20">
            <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
              <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
              </mat-icon>
              <div class="folderName">
                <mat-icon class="folder" *ngIf="node.isShared == false"
                  (click)="showChildFolders(node)">folder</mat-icon>
                <mat-icon class="folder" *ngIf="node.isShared == true"
                  (click)="showChildFolders(node)">folder_shared</mat-icon>
                <span class="flname" (click)="showChildFolders(node)">{{node.name}}</span>
              </div>
            </div>

          </mat-tree-node>
        </mat-tree>

        <div class="folderName" (click)="getSharedWithMeMyDrive()" [ngClass]="{ 'active': SharedWithMeMyDriveactive }">
          <mat-icon class="type">portrait</mat-icon> Shared with me
        </div>

      </div>

      <div class="driveDetail" *ngIf="isShowMyDrive">
        <mat-form-field appearance="fill">
          <mat-label>Search File & Folder... </mat-label>
          <input matInput type="text" [(ngModel)]="searchKey" (keyup)="$event.keyCode == 13
                ? Search($event.target.value)
                : $event.target.value == ''
                ? Search($event.target.value)
                : null" />
          <button [disabled]="searchKey == ''" matSuffix mat-icon-button aria-label="Clear">
             <mat-icon (click)="SearchFilter()">search</mat-icon>
          </button>   
        </mat-form-field>
        <div class="breadcumb pl-5 pr-5">
          <span (click)="breadCrumbMyDriveMainClick()">My Drive</span>
          <span *ngFor="let m of menuHeaderMyDrive;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumbMyDrive(menuHeaderMyDrive, i)">{{ m.label }}</a>
          </span>
        </div>

        <mat-card class="files">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell wstar">&nbsp; </th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell">Name</th>
                <th class="mat-header-cell date">Created On</th>
                <th class="mat-header-cell date">Modified On</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of MyDrivefoldersList; let i = index;">
                <tr class="mat-row foldericon" (click)="radioChangeMyDrive(form)">
                  <td class="mat-cell wstar">
                    <span class="checkbo" *ngIf="form.isFile == true">
                      <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                        (change)="radioChangeMyDrive(form)"></mat-radio-button>
                    </span>
                  </td>

                  <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                    <td class="mat-cell">
                      <mat-icon class="fav">grade</mat-icon>
                    </td>
                  </ng-container>

                  <ng-template #showFavorite>
                    <td class="mat-cell">
                      <mat-icon class="star">grade</mat-icon>
                    </td>
                  </ng-template>

                  <td class="mat-cell docType" *ngIf="form.isFile == false && form.isShared == false">
                    <mat-icon>folder</mat-icon>
                  </td>

                  <td class="mat-cell docType" *ngIf="form.isFile == false && form.isShared == true">
                    <mat-icon>folder_shared</mat-icon>
                  </td>

                  <td class="mat-cell formIcon" *ngIf="form.isFile == true">
                    <ng-container *ngIf="form.fileType == 'pdf'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
                    </ng-container>
                    <ng-container *ngIf="form.fileType == 'png'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/020-png.svg" alt="png File" />
                    </ng-container>
                    <ng-container *ngIf="form.fileType == 'jpg'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File" />
                    </ng-container>
                    <mat-icon *ngIf="form.fileType != 'pdf' && form.fileType != 'png' && form.fileType != 'jpg'">
                      description
                    </mat-icon>
                  </td>

                  <td class="mat-cell" *ngIf="form.isFile == false">
                    <span class="formName" matTooltipClass="tooltip" matTooltipClass="tooltip"
                      matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="form.isFile == true">
                    <p class="formName" matTooltipClass="tooltip" matTooltipClass="tooltip" matTooltip="{{form.name}}">
                      {{ form.name }}</p>
                    <span *ngIf="form.fileSize" class="fileSize">{{ form.fileSize }}</span>
                  </td>

                  <td class="mat-cell">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn!=null">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn==null">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                </tr>
              </ng-container>

              <ng-container *ngIf="foldersMyDriveListShow">
                <tr>
                  <td colspan="7">
                    <p class="nocontent">No Items Found</p>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </mat-card>
      </div>

      <div class="driveDetail" *ngIf="isSharedWithMeMyDrive">
        <div class="breadcumb">
          <span (click)="breadCrumbMainSHaredWithMeMyDriveClick()">Shared with me</span>
          <span *ngFor="let m of menuHeaderMyDrive;let i= index;">
            <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
            <a (click)="breadCrumbSharedWithMeMyDrive(menuHeaderMyDrive, i)">{{ m.label }}</a>
          </span>
        </div>

        <mat-card class="files">
          <table class="mat-table">
            <thead>
              <tr class="mat-header-row">
                <th class="mat-header-cell wstar">&nbsp; </th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell wstar"></th>
                <th class="mat-header-cell">Name</th>
                <th class="mat-header-cell" *ngIf="parentID==0">Shared By</th>
                <th class="mat-header-cell date">Created On</th>
                <th class="mat-header-cell date">Modified On</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let form of SharedWithMeMyDriveFolderList; let i = index;">
                <tr class="mat-row foldericon" (click)="radioChangeMyDriveSharedWithMe(form)">
                  <td class="mat-cell wstar">
                    <span class="checkbo" *ngIf="form.isFile == true">
                      <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                        (change)="radioChangeMyDriveSharedWithMe(form)">

                      </mat-radio-button>
                    </span>
                  </td>

                  <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                    <td class="mat-cell">
                      <mat-icon class="fav">grade</mat-icon>
                    </td>
                  </ng-container>

                  <ng-template #showFavorite>
                    <td class="mat-cell">
                      <mat-icon class="star">grade</mat-icon>
                    </td>
                  </ng-template>

                  <td class="mat-cell docType" *ngIf="form.isFile == false">
                    <mat-icon>folder</mat-icon>
                  </td>

                  <td class="mat-cell formIcon" *ngIf="form.isFile == true">
                    <ng-container *ngIf="form.fileType == 'pdf'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="Pdf File" />
                    </ng-container>
                    <ng-container *ngIf="form.fileType == 'png'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/020-png.svg" alt="png File" />
                    </ng-container>
                    <ng-container *ngIf="form.fileType == 'jpg'">
                      <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File" />
                    </ng-container>
                    <mat-icon *ngIf="form.fileType != 'pdf' && form.fileType != 'png' && form.fileType != 'jpg'">
                      description
                    </mat-icon>
                  </td>

                  <td class="mat-cell" *ngIf="form.isFile == false">
                    <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="form.isFile == true">
                    <p class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</p>
                    <span *ngIf="form.fileSize" class="fileSize">{{ form.fileSize }}</span>
                  </td>

                  <td class="mat-cell" *ngIf="parentID==0">
                    <span class="formName" matTooltipClass="tooltip">
                      {{ form.sharedbyFirstName }} {{ form.sharedbyLastName }}
                    </span>
                  </td>

                  <td class="mat-cell">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn!=null">
                    {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                  <td class="mat-cell" *ngIf="form.updatedOn==null">
                    {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                  </td>

                </tr>
              </ng-container>

              <ng-container *ngIf="SharedWithMeMyDriveFolderList.length==0">
                <tr>
                  <td colspan="7">
                    <p class="nocontent">No Items Found</p>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </mat-card>
      </div>

    </div>


  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="close()">Cancel</button>
    <button mat-button color="primary" [disabled]="!selectButtonMyDriveShow"
      (click)="AddDocumentfromMyDrive()">Select</button>
  </mat-dialog-actions>
</ng-template>